import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
} from '@angular/core';
import { calibrationSettingsIcon } from '../../../../../../shared/icons/toolbars/calibration-settings-icon';

@Component({
  selector: 'h3-calibration-settings-button',
  templateUrl: './calibration-settings-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalibrationSettingsButtonComponent {
  @Input({ required: true }) injector!: Injector;
  @Input({ required: true }) videoOutputName!: string;
  calibrationSettingsIcon = calibrationSettingsIcon;
}
